/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
/**
 * CheckoutModulesStateShare Input Action
 */
export class CartModulesStateShareInput implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `cartSharedState`;
    public getCacheObjectType = () => 'cartSharedState';
    public dataCacheType = (): CacheType => 'request';
}
// TODO: Create a data model here or import one to capture the response of the action
export interface ICartSharedState {
    isCartUpdated?: boolean; // Used to display msg in delivery section
    isQuantityUpdated?: boolean;
}
/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new CartModulesStateShareInput();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function updateCartStateAction(input: CartModulesStateShareInput, ctx: IActionContext): Promise<ICartSharedState> {
    return {
        isCartUpdated: undefined,
        isQuantityUpdated: undefined
    };
}
/**
 * SampleState - create action
 */
export default createObservableDataAction<ICartSharedState>({
    action: <IAction<ICartSharedState>>updateCartStateAction,
    input: createInput
});
